import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from React Router

const teamMembers = [
  { name: 'PROFESSOR PLO LUMUMBA', role: 'Advisor ', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744985586/image-2_wjkk8o.png', page: 'Advisor' },
  { name: 'VUYO NCWAIBA ', role: 'Advisor-Enterprise Devlopment', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744985725/image-3_jwiu2t.png', page: 'Advisor1' },
  { name: 'DR MARY MWALE', role: 'Advisor- Food security', page: 'Advisor7' , image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745440160/image_27_wsy1bb.png'},
  { name: 'Farmers Networks', role: 'Advisor', page: 'Advisor5'  },
  { name: 'Farmers Networks', role: 'Advisor', page: 'Advisor5'  },
  { name: 'Farmers Networks', role: 'Advisor', page: 'Advisor5'  },
];

const extraMembers = [
  { name: 'Allan Oyier', role: 'Founder & CEO', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744986421/image_mnawwp.png', page: 'Advisor2' },
  { name: 'Silas odiero', role: 'Co-founder &  COO', image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744986491/image-1_r1dmnl.png', page: 'Advisor3' },
  { name: 'Farmers Networks', role: 'Executive', page: 'Advisor6'  },
  { name: 'Farmers Networks', role: 'Executive', page: 'Advisor6'  },
  { name: 'Farmers Networks', role: 'Executive', page: 'Advisor6' },
  { name: 'Farmers Networks', role: 'Executive', page: 'Advisor6'  },
  { name: 'Farmers Networks', role: 'Executive', page: 'Advisor6'  },
  { name: 'Farmers Networks', role: 'Executive', page: 'Advisor6' },
];

const countries = [
  { name: 'Gabriel Emvula', role: 'Country Director - NAMIBIA', page: 'Country' },
  { name: 'Country Director', role: 'Country Director - BURUNDI', page: 'Country1' },
  { name: 'Country Director', role: 'Country Director - MALAWI', page: 'Country2' },
  { name: 'Country Director', role: 'Country Director - ZAMBIA', page: 'Country3' },
  { name: 'Country Director', role: 'Country Director - SOUTH AFRICA', page: 'Country4' },
  { name: 'Country Director', role: 'Country Director - KENYA', page: 'Country5' },
];

const iconUrl = 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744986863/Expand_right_1_hhl9ab.png';

const TeamGrid = () => {
  return (
    <div className="md:mt-6 mt-5">
      {/* Team Grid */}
      <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 gap-1 md:gap-6">
        {teamMembers.map((member, index) => (
          <div key={index} className="rounded overflow-hidden shadow">
            <Link to={`/${member.page}`}>
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[80px] sm:h-[240px] md:h-[260px] object-cover bg-[#D9D9D9]"
                />
              ) : (
                <div className="w-full h-[80px] sm:h-[240px] md:h-[260px] bg-[#D9D9D9]" />
              )}
              <div className="bg-[#152C24] text-white p-3 sm:py-5 relative">
                <p className="text-[6px]  md:text-[24px]">{member.name}</p>
                <p className="font-bold text-[6px] sm:text-[20px] md:text-[20px]">{member.role}</p>
                <img src={iconUrl} alt="arrow icon" className="md:w-8 md:h-8 w-4 h-4 absolute bottom-3 right-3" />
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Spacer */}
      <div className="md:my-10 my-4" />

      {/* Final Text Section */}
      <div className="text-[#FDBD26] md:text-[32px] text-[16px] font-bold mb-6">
      THE TEAM
      </div>

      {/* Extra Final Row */}
      <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 md:gap-6 gap-1">
        {extraMembers.map((member, index) => (
          <div key={index} className="rounded overflow-hidden shadow">
            <Link to={`/${member.page}`}>
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[100px] sm:h-[240px] md:h-[260px] object-cover bg-[#D9D9D9]"
                />
              ) : (
                <div className="w-full h-[100px] sm:h-[240px] md:h-[260px] bg-[#D9D9D9]" />
              )}
              <div className="bg-[#152C24] text-white p-3 sm:py-5 relative">
                <p className="text-[6px] sm:text-[20px] md:text-[24px]">{member.name}</p>
                <p className="font-bold text-[6px] sm:text-[20px] md:text-[20px]">{member.role}</p>
                <img src={iconUrl} alt="arrow icon" className="md:w-8 md:h-8 w-4 h-4 absolute bottom-3 right-3" />
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Countries Section */}
      <div className="text-[#FDBD26] md:text-[32px] text-[16px]  font-bold mt-10 mb-6">
        COUNTRIES
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 md:gap-6 gap-1">
        {countries.map((country, index) => (
          <div key={index} className="rounded overflow-hidden shadow">
            <Link to={`/${country.page}`}>
              <div className="w-full h-[100px] sm:h-[240px] md:h-[260px] bg-[#D9D9D9]" />
              <div className="bg-[#152C24] text-white p-3 sm:py-5 relative">
                <p className="text-[6px] sm:text-[20px] md:text-[24px]">{country.name}</p>
                <p className="font-bold text-[6px] sm:text-[20px] md:text-[20px]">{country.role}</p>
                <img src={iconUrl} alt="arrow icon" className="md:w-8 md:h-8 w-4 h-4 absolute bottom-3 right-3" />
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamGrid;
